import { render } from "./TestReportsMenuItem.vue?vue&type=template&id=1d028384"
import script from "./TestReportsMenuItem.vue?vue&type=script&lang=js"
export * from "./TestReportsMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/TestReportsMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d028384"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d028384', __exports__)) {
    console.log('reload')
    api.reload('1d028384', __exports__)
  }
  
  module.hot.accept("./TestReportsMenuItem.vue?vue&type=template&id=1d028384", () => {
    console.log('re-render')
    api.rerender('1d028384', render)
  })

}


export default __exports__